import {User} from './../../core/model/user';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getMenuOptionsByUser',
  standalone: true,
})
export class GetMenuOptionsByUserPipe implements PipeTransform {
  transform(user: User, currentUser: User | null): string[] {
    if (!user || !currentUser) return null;

    const isSameUser = user._id === currentUser._id;
    if (isSameUser) return ['edit'];

    const isUserAdmin = user.roles?.some(role => role.displayName?.toLowerCase() === 'admin');
    if (isUserAdmin) return ['edit'];

    return ['edit', 'delete'];
  }
}
